import script from "./BrowserPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrowserPage.vue?vue&type=script&lang=ts&setup=true"

import "./BrowserPage.vue?vue&type=style&index=0&id=4a08446b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a08446b"]])

export default __exports__